exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-8be66dd2] {\n  font-size: 18px;\n  font-weight: bold;\n  padding: 25px 0;\n  color: #000;\n}\n.content[data-v-8be66dd2] {\n  background-color: #f6f6f6;\n  padding: 45px 45px 20px;\n  border-radius: 10px;\n}\n.editDialog[data-v-8be66dd2] {\n  padding: 50px 100px !important;\n}\n._btn[data-v-8be66dd2] {\n  cursor: pointer;\n  color: #629bfe;\n  padding-left: 15px;\n}\n", ""]);

// exports
